import axios from "axios";
import { getAccessToken } from "../shared/storage";

// @ts-ignore
axios.defaults.baseURL = window["REACT_APP_SETTINGS"].CF_API_ENDPOINT;

axios.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        "x-access-token": getAccessToken(),
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);
